import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Services() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Advanced%20metal%20fabrication%20workshop%20with%20precision%20machinery%2C%20CNC%20equipment%2C%20welding%20stations%2C%20and%20quality%20control%20tools%20in%20modern%20industrial%20facility%20with%20professional%20lighting%20and%20organized%20workspace&width=1920&height=600&seq=services-hero&orientation=landscape')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-amber-300 to-yellow-400 bg-clip-text text-transparent">
            サービス紹介
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            豊富な経験と最新技術で、あらゆる金属加工のニーズにお応えします
          </p>
        </div>
      </section>

      {/* Metal Processing Services */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">金属加工サービス</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              鉄・非鉄・鋳物から表面処理まで、幅広い金属材料の加工に対応
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">鉄・非鉄金属加工</h3>
              <p className="text-lg text-gray-600 mb-6">
                鉄鋼材料から非鉄金属まで、様々な材料の特性を活かした精密加工を行います。お客様の用途に応じて最適な材料選定から加工方法まで、トータルでサポートいたします。
              </p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">炭素鋼・合金鋼加工</span>
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">ステンレス鋼加工</span>
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">アルミニウム・銅合金加工</span>
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">チタン・特殊合金加工</span>
                </li>
              </ul>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20metalworker%20operating%20precision%20cutting%20equipment%20on%20steel%20materials%20in%20modern%20workshop%20with%20safety%20equipment%20and%20quality%20control%20measures%2C%20clean%20industrial%20environment%20with%20organized%20tools&width=600&height=400&seq=metal-processing&orientation=landscape"
                alt="金属加工の様子"
                className="rounded-lg shadow-lg object-cover w-full h-80 border-4 border-amber-400/20"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <img 
                src="https://readdy.ai/api/search-image?query=Industrial%20casting%20and%20foundry%20operations%20with%20molten%20metal%20pouring%2C%20sand%20molds%2C%20and%20surface%20treatment%20equipment%20in%20professional%20foundry%20facility%20with%20safety%20protocols%20and%20quality%20control&width=600&height=400&seq=casting-surface&orientation=landscape"
                alt="鋳物・表面処理"
                className="rounded-lg shadow-lg object-cover w-full h-80 border-4 border-gray-400/20"
              />
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">鋳物・表面処理</h3>
              <p className="text-lg text-gray-600 mb-6">
                鋳造技術による複雑形状の製品製造から、耐食性・耐摩耗性を向上させる各種表面処理まで、製品の性能向上をサポートします。
              </p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">砂型鋳造・金型鋳造</span>
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">ダイカスト・ロストワックス</span>
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">メッキ・アルマイト処理</span>
                </li>
                <li className="flex items-center">
                  <div className="w-6 h-6 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">熱処理・ショットブラスト</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Machine Processing Services */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">機械加工サービス</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              木型製作から精密機械加工まで、高度な技術力でお客様の要求精度を実現
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow border-t-4 border-amber-400">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className="ri-hammer-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">木型製作</h3>
              <p className="text-gray-600 text-center mb-4">
                鋳造用木型の設計・製作を行います。
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• 砂型用木型</li>
                <li>• 金型用マスター</li>
                <li>• 試作品製作</li>
                <li>• 修理・改造</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow border-t-4 border-gray-400">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className="ri-settings-3-line text-3xl text-gray-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">旋盤加工</h3>
              <p className="text-gray-600 text-center mb-4">
                回転体の精密加工を高精度で実現します。
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• 外径・内径加工</li>
                <li>• ねじ切り加工</li>
                <li>• テーパー加工</li>
                <li>• 溝入れ加工</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow border-t-4 border-amber-400">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className="ri-cpu-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">MC加工</h3>
              <p className="text-gray-600 text-center mb-4">
                マシニングセンターによる複雑形状の加工。
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• フライス加工</li>
                <li>• 穴あけ加工</li>
                <li>• タップ加工</li>
                <li>• 3D加工</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow border-t-4 border-gray-400">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className="ri-focus-3-line text-3xl text-gray-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">研削加工</h3>
              <p className="text-gray-600 text-center mb-4">
                高精度な仕上げ加工で理想的な表面を実現。
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• 平面研削</li>
                <li>• 円筒研削</li>
                <li>• 内面研削</li>
                <li>• 成形研削</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Welding & Fabrication Services */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">板金・溶接サービス</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              板金加工から溶接・組立まで、製品製造をトータルサポート
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-8 border-2 border-amber-400">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
                <i className="ri-scissors-cut-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">板金加工</h3>
              <p className="text-gray-600 text-center mb-6">
                薄板から厚板まで、様々な板材の切断・曲げ・成形加工を行います。
              </p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">レーザー切断</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">プレスブレーキ</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">タレットパンチ</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">絞り・深絞り</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-8 border-2 border-gray-400">
              <div className="w-20 h-20 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
                <i className="ri-building-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">製缶加工</h3>
              <p className="text-gray-600 text-center mb-6">
                大型構造物から精密機器まで、製缶技術で様々な製品を製造します。
              </p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">架台・フレーム</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">タンク・容器</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">配管・ダクト</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">機械カバー</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-8 border-2 border-amber-400">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
                <i className="ri-fire-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">溶接・砥石</h3>
              <p className="text-gray-600 text-center mb-6">
                各種溶接技術と砥石加工で、強固で美しい仕上がりを実現します。
              </p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">TIG溶接</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">MIG/MAG溶接</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">アーク溶接</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full mr-3"></div>
                  <span className="text-gray-700">砥石仕上げ</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Quality & Process */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">品質管理・加工プロセス</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              厳格な品質管理体制のもと、お客様に満足いただける製品をお届けします
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">品質保証体制</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                    <i className="ri-shield-check-line text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-900 mb-2">ISO品質基準</h4>
                    <p className="text-gray-600">
                      国際品質基準に準拠した管理体制で、一貫した品質を保証します。
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                    <i className="ri-search-line text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-900 mb-2">全数検査</h4>
                    <p className="text-gray-600">
                      製品の寸法・外観・機能を全数検査し、不良品の流出を防止します。
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                    <i className="ri-file-text-line text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-900 mb-2">検査証明書</h4>
                    <p className="text-gray-600">
                      材料証明書・検査成績書など、必要な書類を完備してお渡しします。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Quality%20control%20inspector%20using%20precision%20measuring%20instruments%20and%20coordinate%20measuring%20machine%20in%20modern%20manufacturing%20facility%20with%20clean%20environment%20and%20professional%20testing%20equipment&width=600&height=400&seq=quality-control&orientation=landscape"
                alt="品質管理の様子"
                className="rounded-lg shadow-lg object-cover w-full h-96 border-4 border-amber-400/20"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-amber-300 to-yellow-400 bg-clip-text text-transparent">
            お客様のご要望をお聞かせください
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-gray-300">
            図面や仕様書をお持ちでない場合でも、お気軽にご相談ください。<br />
            経験豊富なスタッフが最適な加工方法をご提案いたします。
          </p>
          <a 
            href="/contact" 
            className="bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 px-8 py-4 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap inline-block shadow-lg"
          >
            お見積り・ご相談はこちら
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}